import React, { useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import arrow from "../../assets/images/icon_tab/arrow.svg";
import { Tab } from "@headlessui/react";
import ComponentHistoryAttendance from "./ComponentHistoryAttendance";
import ComponentSpecialShift from "./ComponentSpecialShift";
import { setToken } from "../../core/feature/token/tokenSlice";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import * as API from "../../core/service/api.js";
import { removeUser, setUser } from "../../core/feature/user/userSlice";

const ComponentAttendancePro = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);
  var summary = `Riwayat Absensi Pro`;
  var absence = `Riwayat Absensi Khusus`;
  let [categories] = useState({
    [summary]: [],
    [absence]: [],
  });
  const [callerIdentity, setCallerIdentity] = useState<any>([]);
  const [caller, setCaller] = useState<any>("");
  const [isToken, setIsToken] = useState<any>(false);
  const env = Config.BaseUrlDev;

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const handleChangeCallerId = (event: any) => {
    setCaller(event.target.value);
  };

  useEffect(() => {
    console.log(location.pathname.split("/")[2]);

    if (location.pathname.split("/")[2] != undefined) {
      if (location.pathname.split("/")[2] != "token") {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        getData();
      }

      if (location.pathname.split("/")[3] != undefined) {
        var lang = location.pathname.split("/")[3];
        i18n.changeLanguage(lang);
        dispatch(setLanguage(lang));
      }
    }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    getData();
  }, []);
  function getData() {
    API.credentialCheck().then((resCredential) => {
      dispatch(setUser(resCredential.data.user));
      setCallerIdentity(resCredential.data.user.accounts[0].callerIdentities);
      if (resCredential.data.user.accounts[0].callerIdentities.length < 2) {
        setCaller(
          resCredential.data.user.accounts[0].callerIdentities[0].callerId
        );
      }
      // getData();
    });
  }

  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      {!isToken ? (
        <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 ${funBg}`}>
          <TabsMobile
            name={`${t("ATTENDANCE.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div>
      ) : null}
      <div className="flex flex-col bg-psp-primary px-4 py-3">
        <h1 className="font-semibold text-sm ">Akun</h1>
        <div className="flex flex-row gap-2 w-full">
          <select
            className="w-full h-10 text-sm px-2 border-2 border-solid border-psp-gray rounded-lg bg-white"
            value={caller}
            onChange={handleChangeCallerId}
          >
            <option disabled value={""}>
              {"Pilih Akun"}
            </option>
            {callerIdentity.map((option: any) => (
              <option value={option.callerId}>
                {option.name} - {option.callerId}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Tab.Group>
        <Tab.List className="flex justify-between space-x-1 rounded-xl bg-psp-primary h-14 gap-2 px-8">
          {Object.keys(categories).map((category) => (
            <Tab
              key={category}
              className={({ selected }) =>
                classNames(
                  "w-full py-2.5 text-sm font-medium px-2",
                  " ",
                  selected
                    ? "font-montserrat bg-blue-700 text-white text-sm font-semibold rounded-lg"
                    : "text-slate-400 font-montserrat text-sm font-semibold"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <div className="px-4">
          <hr className="mb-0" />
        </div>
        <Tab.Panel className="p-4 top-to-bottom">
          <ComponentHistoryAttendance callerId={caller} />
        </Tab.Panel>
        <Tab.Panel className="p-4 top-to-bottom">
          <ComponentSpecialShift callerId={caller} />
        </Tab.Panel>
      </Tab.Group>
    </div>
  );
};

export default ComponentAttendancePro;
